export default `MARKDOWN:
Pay the membership fee to:
- Bank transfer: 4200 32 16513
- Vipps: #622814

**Remember to mark the payment with your name!**

*For exchange students: Payment must be made by card at our payment terminal at Moholt student village. Please email mail@studenteneskameraklubb.no to arrange a meeting with a board member, who will help you complete the payment and registration process. Our bank charges a 50 NOK fee for international transfers, so this is the easiest solution.

Once we have confirmed your payment, you are officially a member of Studentenes Kameraklubb.
If you encounter any problems, please do not hesitate to contact us via email or Facebook.
`;
